module.exports = __webpack_public_path__ + "img/powered_by_qsignal.0f2d070b.svg";